require('./retailLoanEmailModal.scss');
//@vendor
const React = require('react');
const PropTypes = require('prop-types');
//@core
const { FormattedText, formatText } = require('core/i18n').i18n;
//@commons
const { InputSafe } = require('commonsComponents/inputSafe');
const { OKMessage } = require('commonsComponents/OKMessage');
const OKModal = require('components/commons/OKModal/OKModal');
// @ constants
const { EMAIL_REGEX } = require('constants/index');
const {
    retailLoanDoTaggin: {
        NAME_PAGE_WIZARD_VIEW,
        TAGGING_LOAD_EMAIL_MODAL,
        TAGGING_VIEW, TAGGING_SAVE,
        TAGGING_CLOSE,
        TAGGING_CANCEL,
    },
} = require('../../../../loansConstants/index');
//@helpers
const { buildEventsModal } = require('../../../../loansUtilities/loansHelper');
// @ utilities
const {
    recordLinkV2,
} = require('utilities/tagging');

class RetailLoanEmailModal extends React.Component {
    constructor(props) {
        super(props);
        const { email } = props;

        this.state = {
            newEmail: email,
            newEmailValid: false,
            hasAcceptedTermsAndConditions: false
        };

        this.isValidNewEmail = this.isValidNewEmail.bind(this);
        this.handleEmailOnBlur = this.handleEmailOnBlur.bind(this);
        this.handleSaveNewEmail = this.handleSaveNewEmail.bind(this);
        this.handleChangeNewEmail = this.handleChangeNewEmail.bind(this);
        this.handleCancelChangeEmail = this.handleCancelChangeEmail.bind(this);
    }

    componentDidUpdate(prevProps) {
        const { showModal } = this.props;

        if (prevProps.showModal !== showModal && showModal) {
            const customData = buildEventsModal(TAGGING_LOAD_EMAIL_MODAL, TAGGING_VIEW, NAME_PAGE_WIZARD_VIEW);
            recordLinkV2(customData);
        }
    }

    isValidNewEmail(currentValue) {
        const emailIsValid = EMAIL_REGEX.test(currentValue);
        return this.state.newEmail !== '' && emailIsValid;
    }

    handleChangeNewEmail(event) {
        const { value } = event.target;
        this.setState({
            newEmail: value,
            newEmailValid: false
        });
    }

    handleEmailOnBlur(event) {
        const { value } = event.target;
        const emailValidation = this.isValidNewEmail(value);
        let validation = false;

        if (!emailValidation) {
            validation = true;
        } else {
            validation = false;
        }

        this.setState({
            newEmailValid: validation
        });
    }

    handleCancelChangeEmail(tagEvent) {
        const { email, onHandleToggleModal } = this.props;
        this.setState({
            newEmail: email,
            newEmailValid: false
        });

        return onHandleToggleModal(tagEvent);
    }

    handleSaveNewEmail(evt) {
        evt.preventDefault();

        const { setEmail, onHandleToggleModal } = this.props;
        const { newEmail } = this.state;
        const emailValidation = this.isValidNewEmail(newEmail);

        if (emailValidation) {
            setEmail({ newEmail });
            onHandleToggleModal(TAGGING_SAVE);
        }
    }

    buildModal() {
        const errorMessage = formatText('contractRetailLoanEmailModal-emailError');

        return (
            <React.Fragment>
                <div className="retail-loan-email-modal__input">
                    <InputSafe
                        label={formatText('contractRetailLoanEmailModal-subTitle')}
                        name="email"
                        value={this.state.newEmail}
                        type="text"
                        disabled={false}
                        onChange={this.handleChangeNewEmail}
                        onBlur={this.handleEmailOnBlur}
                        errorState={this.state.newEmailValid}
                        errorMessage={errorMessage}
                    />
                </div>
                <OKMessage type="important">
                    <FormattedText value="contractRetailLoanEmailModal-disclamer" />
                </OKMessage>
            </React.Fragment>
        );
    }

    render() {
        const { showModal } = this.props;
        const modalContent = this.buildModal();

        return (
            <OKModal
                content={modalContent}
                footerType="navigation"
                isOpen={showModal}
                onCloseCallback={() => this.handleCancelChangeEmail(TAGGING_CLOSE)}
                onPrimaryButtonClick={this.handleSaveNewEmail}
                onSecondaryButtonClick={() => this.handleCancelChangeEmail(TAGGING_CANCEL)}
                primaryButtonText="contractRetailLoanEmailModal-save"
                secondaryButtonText="contractRetailLoanEmailModal-cancel"
                title="contractRetailLoanEmailModal-title"
            />
        )
    }
}

RetailLoanEmailModal.propTypes = {
    showModal: PropTypes.bool,
    onHandleToggleModal: PropTypes.func.isRequired,
    email: PropTypes.string,
    setEmail: PropTypes.func.isRequired
};


module.exports = RetailLoanEmailModal;
